"use client";

// Footer "Cookie settings" control. Lets visitors reopen the consent banner to
// change or withdraw their choice (GDPR/DPDP require this to be as easy as
// giving consent). Rendered as an <a> so it inherits the exact `.fc-l a`
// footer-link styling — including the hover marker and responsive sizing — with
// zero new CSS, while behaving as a button (keyboard-activatable).

export default function CookieSettingsLink() {
  const open = () => window.dispatchEvent(new Event("lexvio:open-consent"));
  return (
    <a
      role="button"
      style={{ cursor: "pointer" }}
      tabIndex={0}
      onClick={open}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          open();
        }
      }}
    >
      Cookie settings
    </a>
  );
}
